/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutPortfolioRouteImport } from './routes/_layoutPortfolio'
import { Route as LayoutPortfolioIndexRouteImport } from './routes/_layoutPortfolio/index'
import { Route as LayoutPortfolioAccountRouteImport } from './routes/_layoutPortfolio/account'
import { Route as LayoutPortfolioHistoryIndexRouteImport } from './routes/_layoutPortfolio/history/index'
import { Route as LayoutPortfolioDashboardIndexRouteImport } from './routes/_layoutPortfolio/dashboard/index'

const WaitlistLazyRouteImport = createFileRoute('/waitlist')()
const SignInLazyRouteImport = createFileRoute('/signIn')()
const OnboardingLazyRouteImport = createFileRoute('/onboarding')()
const MaintenanceLazyRouteImport = createFileRoute('/maintenance')()
const ForbidMultitabLazyRouteImport = createFileRoute('/forbid-multitab')()
const SignInFactorOneLazyRouteImport = createFileRoute('/signIn/factor-one')()
const LayoutPortfolioSettingIndexLazyRouteImport = createFileRoute(
  '/_layoutPortfolio/setting/',
)()
const LayoutPortfolioSettingShareLazyRouteImport = createFileRoute(
  '/_layoutPortfolio/setting/share',
)()
const LayoutPortfolioSettingPlanLazyRouteImport = createFileRoute(
  '/_layoutPortfolio/setting/plan',
)()
const LayoutPortfolioSettingJournalLazyRouteImport = createFileRoute(
  '/_layoutPortfolio/setting/journal',
)()
const LayoutPortfolioHistoryListLazyRouteImport = createFileRoute(
  '/_layoutPortfolio/history/list',
)()
const LayoutPortfolioDashboardExportLazyRouteImport = createFileRoute(
  '/_layoutPortfolio/dashboard/export',
)()

const WaitlistLazyRoute = WaitlistLazyRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/waitlist.lazy').then((d) => d.Route))
const SignInLazyRoute = SignInLazyRouteImport.update({
  id: '/signIn',
  path: '/signIn',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/signIn.lazy').then((d) => d.Route))
const OnboardingLazyRoute = OnboardingLazyRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/onboarding.lazy').then((d) => d.Route))
const MaintenanceLazyRoute = MaintenanceLazyRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/maintenance.lazy').then((d) => d.Route))
const ForbidMultitabLazyRoute = ForbidMultitabLazyRouteImport.update({
  id: '/forbid-multitab',
  path: '/forbid-multitab',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/forbid-multitab.lazy').then((d) => d.Route),
)
const LayoutPortfolioRoute = LayoutPortfolioRouteImport.update({
  id: '/_layoutPortfolio',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutPortfolioIndexRoute = LayoutPortfolioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutPortfolioRoute,
} as any)
const SignInFactorOneLazyRoute = SignInFactorOneLazyRouteImport.update({
  id: '/factor-one',
  path: '/factor-one',
  getParentRoute: () => SignInLazyRoute,
} as any).lazy(() =>
  import('./routes/signIn/factor-one.lazy').then((d) => d.Route),
)
const LayoutPortfolioAccountRoute = LayoutPortfolioAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => LayoutPortfolioRoute,
} as any).lazy(() =>
  import('./routes/_layoutPortfolio/account.lazy').then((d) => d.Route),
)
const LayoutPortfolioSettingIndexLazyRoute =
  LayoutPortfolioSettingIndexLazyRouteImport.update({
    id: '/setting/',
    path: '/setting/',
    getParentRoute: () => LayoutPortfolioRoute,
  } as any).lazy(() =>
    import('./routes/_layoutPortfolio/setting/index.lazy').then((d) => d.Route),
  )
const LayoutPortfolioHistoryIndexRoute =
  LayoutPortfolioHistoryIndexRouteImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => LayoutPortfolioRoute,
  } as any).lazy(() =>
    import('./routes/_layoutPortfolio/history/index.lazy').then((d) => d.Route),
  )
const LayoutPortfolioDashboardIndexRoute =
  LayoutPortfolioDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => LayoutPortfolioRoute,
  } as any).lazy(() =>
    import('./routes/_layoutPortfolio/dashboard/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutPortfolioSettingShareLazyRoute =
  LayoutPortfolioSettingShareLazyRouteImport.update({
    id: '/setting/share',
    path: '/setting/share',
    getParentRoute: () => LayoutPortfolioRoute,
  } as any).lazy(() =>
    import('./routes/_layoutPortfolio/setting/share.lazy').then((d) => d.Route),
  )
const LayoutPortfolioSettingPlanLazyRoute =
  LayoutPortfolioSettingPlanLazyRouteImport.update({
    id: '/setting/plan',
    path: '/setting/plan',
    getParentRoute: () => LayoutPortfolioRoute,
  } as any).lazy(() =>
    import('./routes/_layoutPortfolio/setting/plan.lazy').then((d) => d.Route),
  )
const LayoutPortfolioSettingJournalLazyRoute =
  LayoutPortfolioSettingJournalLazyRouteImport.update({
    id: '/setting/journal',
    path: '/setting/journal',
    getParentRoute: () => LayoutPortfolioRoute,
  } as any).lazy(() =>
    import('./routes/_layoutPortfolio/setting/journal.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutPortfolioHistoryListLazyRoute =
  LayoutPortfolioHistoryListLazyRouteImport.update({
    id: '/history/list',
    path: '/history/list',
    getParentRoute: () => LayoutPortfolioRoute,
  } as any).lazy(() =>
    import('./routes/_layoutPortfolio/history/list.lazy').then((d) => d.Route),
  )
const LayoutPortfolioDashboardExportLazyRoute =
  LayoutPortfolioDashboardExportLazyRouteImport.update({
    id: '/dashboard/export',
    path: '/dashboard/export',
    getParentRoute: () => LayoutPortfolioRoute,
  } as any).lazy(() =>
    import('./routes/_layoutPortfolio/dashboard/export.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/forbid-multitab': typeof ForbidMultitabLazyRoute
  '/maintenance': typeof MaintenanceLazyRoute
  '/onboarding': typeof OnboardingLazyRoute
  '/signIn': typeof SignInLazyRouteWithChildren
  '/waitlist': typeof WaitlistLazyRoute
  '/account': typeof LayoutPortfolioAccountRoute
  '/signIn/factor-one': typeof SignInFactorOneLazyRoute
  '/': typeof LayoutPortfolioIndexRoute
  '/dashboard/export': typeof LayoutPortfolioDashboardExportLazyRoute
  '/history/list': typeof LayoutPortfolioHistoryListLazyRoute
  '/setting/journal': typeof LayoutPortfolioSettingJournalLazyRoute
  '/setting/plan': typeof LayoutPortfolioSettingPlanLazyRoute
  '/setting/share': typeof LayoutPortfolioSettingShareLazyRoute
  '/dashboard': typeof LayoutPortfolioDashboardIndexRoute
  '/history': typeof LayoutPortfolioHistoryIndexRoute
  '/setting': typeof LayoutPortfolioSettingIndexLazyRoute
}
export interface FileRoutesByTo {
  '/forbid-multitab': typeof ForbidMultitabLazyRoute
  '/maintenance': typeof MaintenanceLazyRoute
  '/onboarding': typeof OnboardingLazyRoute
  '/signIn': typeof SignInLazyRouteWithChildren
  '/waitlist': typeof WaitlistLazyRoute
  '/account': typeof LayoutPortfolioAccountRoute
  '/signIn/factor-one': typeof SignInFactorOneLazyRoute
  '/': typeof LayoutPortfolioIndexRoute
  '/dashboard/export': typeof LayoutPortfolioDashboardExportLazyRoute
  '/history/list': typeof LayoutPortfolioHistoryListLazyRoute
  '/setting/journal': typeof LayoutPortfolioSettingJournalLazyRoute
  '/setting/plan': typeof LayoutPortfolioSettingPlanLazyRoute
  '/setting/share': typeof LayoutPortfolioSettingShareLazyRoute
  '/dashboard': typeof LayoutPortfolioDashboardIndexRoute
  '/history': typeof LayoutPortfolioHistoryIndexRoute
  '/setting': typeof LayoutPortfolioSettingIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layoutPortfolio': typeof LayoutPortfolioRouteWithChildren
  '/forbid-multitab': typeof ForbidMultitabLazyRoute
  '/maintenance': typeof MaintenanceLazyRoute
  '/onboarding': typeof OnboardingLazyRoute
  '/signIn': typeof SignInLazyRouteWithChildren
  '/waitlist': typeof WaitlistLazyRoute
  '/_layoutPortfolio/account': typeof LayoutPortfolioAccountRoute
  '/signIn/factor-one': typeof SignInFactorOneLazyRoute
  '/_layoutPortfolio/': typeof LayoutPortfolioIndexRoute
  '/_layoutPortfolio/dashboard/export': typeof LayoutPortfolioDashboardExportLazyRoute
  '/_layoutPortfolio/history/list': typeof LayoutPortfolioHistoryListLazyRoute
  '/_layoutPortfolio/setting/journal': typeof LayoutPortfolioSettingJournalLazyRoute
  '/_layoutPortfolio/setting/plan': typeof LayoutPortfolioSettingPlanLazyRoute
  '/_layoutPortfolio/setting/share': typeof LayoutPortfolioSettingShareLazyRoute
  '/_layoutPortfolio/dashboard/': typeof LayoutPortfolioDashboardIndexRoute
  '/_layoutPortfolio/history/': typeof LayoutPortfolioHistoryIndexRoute
  '/_layoutPortfolio/setting/': typeof LayoutPortfolioSettingIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/forbid-multitab'
    | '/maintenance'
    | '/onboarding'
    | '/signIn'
    | '/waitlist'
    | '/account'
    | '/signIn/factor-one'
    | '/'
    | '/dashboard/export'
    | '/history/list'
    | '/setting/journal'
    | '/setting/plan'
    | '/setting/share'
    | '/dashboard'
    | '/history'
    | '/setting'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forbid-multitab'
    | '/maintenance'
    | '/onboarding'
    | '/signIn'
    | '/waitlist'
    | '/account'
    | '/signIn/factor-one'
    | '/'
    | '/dashboard/export'
    | '/history/list'
    | '/setting/journal'
    | '/setting/plan'
    | '/setting/share'
    | '/dashboard'
    | '/history'
    | '/setting'
  id:
    | '__root__'
    | '/_layoutPortfolio'
    | '/forbid-multitab'
    | '/maintenance'
    | '/onboarding'
    | '/signIn'
    | '/waitlist'
    | '/_layoutPortfolio/account'
    | '/signIn/factor-one'
    | '/_layoutPortfolio/'
    | '/_layoutPortfolio/dashboard/export'
    | '/_layoutPortfolio/history/list'
    | '/_layoutPortfolio/setting/journal'
    | '/_layoutPortfolio/setting/plan'
    | '/_layoutPortfolio/setting/share'
    | '/_layoutPortfolio/dashboard/'
    | '/_layoutPortfolio/history/'
    | '/_layoutPortfolio/setting/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutPortfolioRoute: typeof LayoutPortfolioRouteWithChildren
  ForbidMultitabLazyRoute: typeof ForbidMultitabLazyRoute
  MaintenanceLazyRoute: typeof MaintenanceLazyRoute
  OnboardingLazyRoute: typeof OnboardingLazyRoute
  SignInLazyRoute: typeof SignInLazyRouteWithChildren
  WaitlistLazyRoute: typeof WaitlistLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signIn': {
      id: '/signIn'
      path: '/signIn'
      fullPath: '/signIn'
      preLoaderRoute: typeof SignInLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbid-multitab': {
      id: '/forbid-multitab'
      path: '/forbid-multitab'
      fullPath: '/forbid-multitab'
      preLoaderRoute: typeof ForbidMultitabLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layoutPortfolio': {
      id: '/_layoutPortfolio'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutPortfolioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layoutPortfolio/': {
      id: '/_layoutPortfolio/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutPortfolioIndexRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    '/signIn/factor-one': {
      id: '/signIn/factor-one'
      path: '/factor-one'
      fullPath: '/signIn/factor-one'
      preLoaderRoute: typeof SignInFactorOneLazyRouteImport
      parentRoute: typeof SignInLazyRoute
    }
    '/_layoutPortfolio/account': {
      id: '/_layoutPortfolio/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof LayoutPortfolioAccountRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    '/_layoutPortfolio/setting/': {
      id: '/_layoutPortfolio/setting/'
      path: '/setting'
      fullPath: '/setting'
      preLoaderRoute: typeof LayoutPortfolioSettingIndexLazyRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    '/_layoutPortfolio/history/': {
      id: '/_layoutPortfolio/history/'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof LayoutPortfolioHistoryIndexRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    '/_layoutPortfolio/dashboard/': {
      id: '/_layoutPortfolio/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof LayoutPortfolioDashboardIndexRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    '/_layoutPortfolio/setting/share': {
      id: '/_layoutPortfolio/setting/share'
      path: '/setting/share'
      fullPath: '/setting/share'
      preLoaderRoute: typeof LayoutPortfolioSettingShareLazyRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    '/_layoutPortfolio/setting/plan': {
      id: '/_layoutPortfolio/setting/plan'
      path: '/setting/plan'
      fullPath: '/setting/plan'
      preLoaderRoute: typeof LayoutPortfolioSettingPlanLazyRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    '/_layoutPortfolio/setting/journal': {
      id: '/_layoutPortfolio/setting/journal'
      path: '/setting/journal'
      fullPath: '/setting/journal'
      preLoaderRoute: typeof LayoutPortfolioSettingJournalLazyRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    '/_layoutPortfolio/history/list': {
      id: '/_layoutPortfolio/history/list'
      path: '/history/list'
      fullPath: '/history/list'
      preLoaderRoute: typeof LayoutPortfolioHistoryListLazyRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
    '/_layoutPortfolio/dashboard/export': {
      id: '/_layoutPortfolio/dashboard/export'
      path: '/dashboard/export'
      fullPath: '/dashboard/export'
      preLoaderRoute: typeof LayoutPortfolioDashboardExportLazyRouteImport
      parentRoute: typeof LayoutPortfolioRoute
    }
  }
}

interface LayoutPortfolioRouteChildren {
  LayoutPortfolioAccountRoute: typeof LayoutPortfolioAccountRoute
  LayoutPortfolioIndexRoute: typeof LayoutPortfolioIndexRoute
  LayoutPortfolioDashboardExportLazyRoute: typeof LayoutPortfolioDashboardExportLazyRoute
  LayoutPortfolioHistoryListLazyRoute: typeof LayoutPortfolioHistoryListLazyRoute
  LayoutPortfolioSettingJournalLazyRoute: typeof LayoutPortfolioSettingJournalLazyRoute
  LayoutPortfolioSettingPlanLazyRoute: typeof LayoutPortfolioSettingPlanLazyRoute
  LayoutPortfolioSettingShareLazyRoute: typeof LayoutPortfolioSettingShareLazyRoute
  LayoutPortfolioDashboardIndexRoute: typeof LayoutPortfolioDashboardIndexRoute
  LayoutPortfolioHistoryIndexRoute: typeof LayoutPortfolioHistoryIndexRoute
  LayoutPortfolioSettingIndexLazyRoute: typeof LayoutPortfolioSettingIndexLazyRoute
}

const LayoutPortfolioRouteChildren: LayoutPortfolioRouteChildren = {
  LayoutPortfolioAccountRoute: LayoutPortfolioAccountRoute,
  LayoutPortfolioIndexRoute: LayoutPortfolioIndexRoute,
  LayoutPortfolioDashboardExportLazyRoute:
    LayoutPortfolioDashboardExportLazyRoute,
  LayoutPortfolioHistoryListLazyRoute: LayoutPortfolioHistoryListLazyRoute,
  LayoutPortfolioSettingJournalLazyRoute:
    LayoutPortfolioSettingJournalLazyRoute,
  LayoutPortfolioSettingPlanLazyRoute: LayoutPortfolioSettingPlanLazyRoute,
  LayoutPortfolioSettingShareLazyRoute: LayoutPortfolioSettingShareLazyRoute,
  LayoutPortfolioDashboardIndexRoute: LayoutPortfolioDashboardIndexRoute,
  LayoutPortfolioHistoryIndexRoute: LayoutPortfolioHistoryIndexRoute,
  LayoutPortfolioSettingIndexLazyRoute: LayoutPortfolioSettingIndexLazyRoute,
}

const LayoutPortfolioRouteWithChildren = LayoutPortfolioRoute._addFileChildren(
  LayoutPortfolioRouteChildren,
)

interface SignInLazyRouteChildren {
  SignInFactorOneLazyRoute: typeof SignInFactorOneLazyRoute
}

const SignInLazyRouteChildren: SignInLazyRouteChildren = {
  SignInFactorOneLazyRoute: SignInFactorOneLazyRoute,
}

const SignInLazyRouteWithChildren = SignInLazyRoute._addFileChildren(
  SignInLazyRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  LayoutPortfolioRoute: LayoutPortfolioRouteWithChildren,
  ForbidMultitabLazyRoute: ForbidMultitabLazyRoute,
  MaintenanceLazyRoute: MaintenanceLazyRoute,
  OnboardingLazyRoute: OnboardingLazyRoute,
  SignInLazyRoute: SignInLazyRouteWithChildren,
  WaitlistLazyRoute: WaitlistLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
